import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-delivery-fast",
  "use": "icon-icon-delivery-fast-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-delivery-fast\">\n    <title>icons/icon-delivery-fast</title>\n    <g id=\"icon-icon-delivery-fast_icons/icon-delivery-fast\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon-icon-delivery-fast_Oval-Copy\" fill=\"#8CF8B0\" cx=\"12\" cy=\"12\" r=\"4\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol